// extracted by mini-css-extract-plugin
export default {"spinner":"ChatSpinner_spinner__tWkv0","dot":"ChatSpinner_dot__SdhUs","blink":"ChatSpinner_blink__yJIoi"};